import JSON5 from 'json5';
export default class FocusOn{
	_targetFocus($el, opt){
		let $target;
		if(opt.targetInside){
			$target = $el.find(opt.target);
		} else if (opt.targetSelf) {
			$target = $el;
		}
		else{
			$target = $(opt.target);
		}
		$target.focus();
	}
	constructor($els){
		$els.each((i, el) => {
			let $this = $(el);
			let opt = JSON5.parse($this.attr('data-focuson'));
			if(opt.on !== 'load'){
				$this.on(opt.on, () =>{
					setTimeout(()=> {
						if(opt.condition){
							if($(opt.condition).length){
								this._targetFocus($this, opt);
							}
						} else{
							this._targetFocus($this, opt);
						}
					}, opt.delay || 0);
				});
			} else{
				this._targetFocus($this, opt);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/_js/partials/focuson.js